if (!customElements.get('product-page-purchased')) {
  class ProductPurchased extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const url = new URL(window.location.href);
      const param = this.dataset.param;
      if (url.searchParams.has(param)) {
        this.classList.add('visible');
      }
    }
  }

  customElements.define('product-page-purchased', ProductPurchased);
}
